import React from 'react';
import ProductDashboardPage from '@/components/dashboard/ProductDashboardPage';

const UserFestgeld = () => {
  return (
    <ProductDashboardPage
      title="Festgeld"
      productType="Festgeld"
      subtitle="Sicher und planbar — Ihre Festgeldanlagen mit fester Laufzeit und garantiertem Zinssatz."
      ctaLabel="Neues Festgeld eröffnen"
    />
  );
};

export default UserFestgeld;
